import { useCallback, useMemo } from "react"

import { useParams } from "react-router-dom"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { NoteAddRoundedIcon } from "@l2r-front/l2r-icons"
import { useMapDispatchContext } from "@l2r-front/l2r-map"
import { LinearLocationSelector, LINEAR_LOCATION_ROAD, LINEAR_LOCATION_SECTION } from "@l2r-front/l2r-networks"
import { PropTypes } from "@l2r-front/l2r-proptypes"

import { I18N_NAMESPACE } from "../../constants/i18n"
import { API_MODULE_DOCUMENT, ROAD_ATTACHMENT } from "../../constants/modules"

export function DocumentLinearLocationSelector(props) {

    const {
        onClose,
        onLinearLocationSelected,
        selectionType,
        ...otherProps
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)
    const { road } = useParams()
    const { getMapRef } = useMapDispatchContext()

    const initialBoundingBox = useMemo(() => {
        const map = getMapRef()?.getMap()
        if (!road && map) {
            const [minLng, minLat, maxLng, maxLat] = map.getBounds().toArray().flat()
            return ({
                minLng: minLng,
                minLat,
                maxLng: maxLng,
                maxLat,
            })
        }
        return null
    }, [getMapRef, road])

    const handleCancel = useCallback(() => {
        onLinearLocationSelected(null)
        onClose()
    }, [onClose, onLinearLocationSelected])

    return <LinearLocationSelector
        {...otherProps}
        cancelButtonLabel={t(I18N_NAMESPACE, "components.documentSelectLinearLocation.button.cancel")}
        desc={selectionType.toLowerCase() === ROAD_ATTACHMENT ? t(I18N_NAMESPACE, "components.documentSelectLinearLocation.descRoad") : t(I18N_NAMESPACE, "components.documentSelectLinearLocation.descSection")}
        initialBoundingBox={initialBoundingBox}
        module={API_MODULE_DOCUMENT}
        onCancel={handleCancel}
        selectionType={selectionType}
        onValidateLinearLocation={onLinearLocationSelected}
        title={t(I18N_NAMESPACE, "components.documentSelectLinearLocation.title")}
        titleIcon={<NoteAddRoundedIcon />}
        validateButtonLabel={t(I18N_NAMESPACE, "components.documentSelectLinearLocation.button.save")}
    />
}

DocumentLinearLocationSelector.propTypes = {
    onClose: PropTypes.func.isRequired,
    onLinearLocationSelected: PropTypes.func.isRequired,
    selectedLinearLocation: PropTypes.linearLocation,
    selectionType: PropTypes.oneOf([LINEAR_LOCATION_ROAD, LINEAR_LOCATION_SECTION]),
}
